<template>
    <div class="carwash-clinic">
        <div class="inner">
            <h1 class="h3">{{ $t('clinic.heading') }}</h1>
            <BlocksCarwashClinicSurvey @completed="scrollTo()" />
        </div>
        <section ref="results">
            <BlocksCardList
                v-bind="props"
                :display="{component: 'cards'}"
                :cards="cards"
            />
        </section>
    </div>
</template>
<script setup>
import { useI18n, onMounted, ref } from '#imports';
import { useCarwashClinicStore } from '~dsc/stores/cms/carwashclinic';

const clinic = useCarwashClinicStore();
const props = defineProps({
    id: {
        type: String,
        required: false,
        default: '',
    },
    contentType: {
        type: String,
        required: false,
        default: 'cardList',
    },
    internal: {
        type: String,
        required: false,
        default: '',
    },
    display: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    cards: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const results = ref(null);

const scrollTo = () => {
    results.value?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

onMounted(() => {
    clinic.setProducts(props.cards);
});

useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            clinic: {
                heading: 'Mikä pesu autollesi sopii? Tee testi!',

            },
        },
        'en-EU': {
            clinic: {
                heading: 'Mikä pesu autollesi sopii? Tee testi!',
            },
        },
    },
});
</script>
<style scoped>
.carwash-clinic {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.carwash-clinic .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.carwash-clinic {
  grid-gap: 4rem 0;
}

.h3 {
  margin-top: 2rem;
}

.inner .product {
  position: relative;
  justify-content: center;
  align-items: center;
  padding-inline: 0.5rem;
}
.inner.slider {
  margin-bottom: 4rem;
}

:deep(.product) .content .image-container {
  padding: 1rem 1rem 0;
}
</style>
